import { useGetCurriculumCertificatesQuery } from '~/curriculum/apis/curriculum.api'
import { getTestGenerationStatus } from '~/tests/utils/testUtils'
import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'

import MasteryCertificates from './MasteryCertificates'
import TestPrep from './TestPrep'

const CertificateAndTestPrep: React.FC<{
  currentGrade: number
  countryCode: CurriculumCountryCodes
}> = ({ currentGrade, countryCode }) => {
  const certificates = useGetCurriculumCertificatesQuery()?.data

  const { isAllowed, isComingSoon, isNotAllowed } = getTestGenerationStatus(currentGrade, countryCode)

  return (
    <div className="flex lg:flex-col gap-4 w-full h-full justify-center items-center">
      {!isNotAllowed && (
        <div className="relative flex justify-center items-center bg-purple-cosmos border border-white-veil rounded-4 w-full h-full lg:flex-1 lg:min-h-0">
          <span className="-top-3 -right-3 absolute bg-pink shadow px-2 py-0.5 rounded-full font-semibold text-white text-xs rotate-4">
            Beta
          </span>
          <TestPrep isAllowed={isAllowed} isComingSoon={isComingSoon} />
        </div>
      )}
      <div className="flex justify-center items-center bg-purple-cosmos border border-white-veil rounded-4 w-full h-full max-h-80 order-first lg:order-none lg:max-h-none lg:flex-1 lg:min-h-0">
        <MasteryCertificates certificates={certificates} largeBadge={isNotAllowed} />
      </div>
    </div>
  )
}

export default CertificateAndTestPrep
